<!-- Car Hire -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (car.detail; as detail) {
      <div>
        <div [class.duplicate-item-wrapper]="duplicateBooking">
          @if (duplicateBooking) {
            <div class="duplicate-item-date">
              <i class="ico-car" aria-hidden="true"></i>&nbsp;
              <span i18n="@@basketPanelPickUpCarHire">Pick up:</span>
              @if (detail.pickUpDatetime; as pickUpDatetime) {
                <strong>{{ pickUpDatetime | sabsDate: 5 }}</strong>
                <!-- <strong >{{ pickUpDatetime | date: 'HH:mm' }}</strong> -->
              }
            </div>
          }
          <div class="cart_item_heading">
            @if (!duplicateBooking) {
              <i class="ico-car" aria-hidden="true"></i>&nbsp;
            }
            @if (displayHeading) {
              <strong>{{ displayHeading | splitCamelCase | translate }}</strong>
            }
            @if (!duplicateBooking) {
              <section (mouseleave)="tt1.close()">
                <button
                  class="cart_item_remove ico-trash"
                  ngbTooltip="Remove {{ detail.car?.type }} car hire from your {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-ngbTooltip
                  attr.aria-label="Remove {{ detail.car?.type }} car hire from your {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-aria-label
                  (click)="remove.emit()"
                  triggers="manual"
                  #tt1="ngbTooltip"
                  (mouseenter)="tt1.open()"
                  (focus)="tt1.open()"
                  (blur)="tt1.close()"
                  id="remove-basketitem-{{ car.id }}"
                ></button>
              </section>
            }
            @if (!duplicateBooking) {
              <section (mouseleave)="tt2.close()">
                <img
                  src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                    displayItinerary ? 'luggage_icon' : 'basket_move'
                  }}.svg"
                  class="move_basket_icon"
                  role="button"
                  ngbTooltip="Move to different {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-ngbTooltip
                  attr.aria-label="Move {{ detail.car?.type }} car hire to different {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-aria-label
                  (click)="openChangeModal.emit()"
                  (keydown.enter)="openChangeModal.emit()"
                  (keydown.space)="openChangeModal.emit()"
                  triggers="manual"
                  #tt2="ngbTooltip"
                  (mouseenter)="tt2.open()"
                  (focus)="tt2.open()"
                  (blur)="tt2.close()"
                  tabindex="0"
                  id="share-basketitem-{{ car.id }}"
                />
              </section>
            }
          </div>
          <div class="car_cart_item_from_point" id="car_from_point_{{ car.id }}">
            @if (detail.pickUpLocation; as pickUpLocation) {
              <div>
                <span i18n="@@itineraryCabFromLocation">Pick-up location:</span>
                {{ pickUpLocation.address }}, {{ pickUpLocation.postcode }}
              </div>
            }
            @if (!duplicateBooking && detail.pickUpDatetime; as pickUpDatetime) {
              <div>
                <span i18n="@@carHireBasketPickUp">Pick-up date and time:</span>
                {{ pickUpDatetime | sabsDate: 5 }}
              </div>
            }
          </div>
        </div>
        <div [class.duplicate-item-wrapper]="duplicateBooking">
          @if (duplicateBooking) {
            <div class="duplicate-item-date">
              <i class="ico-car" aria-hidden="true"></i>&nbsp;
              <span i18n="@@basketPanelDropOffCarHire">Drop off:</span>
              @if (detail.dropOffDatetime; as dropOffDatetime) {
                <strong>{{ dropOffDatetime | sabsDate: 5 }}</strong>
                <!-- <strong >{{ dropOffDatetime | date: 'HH:mm' }}</strong> -->
              }
            </div>
          }
          <div class="car_cart_item_to_point" id="car_to_point_{{ car.id }}">
            @if (detail.dropOffLocation; as dropOffLocation) {
              <div>
                <span i18n="@@itineraryCabToLocation">Drop-off location:</span>
                {{ dropOffLocation.address }}, {{ dropOffLocation.postcode }}
              </div>
            }
            @if (!duplicateBooking && detail.dropOffDatetime; as dropOffDatetime) {
              <div>
                <span i18n="@@carHireBasketDropOff">Drop-off date and time:</span>
                {{ dropOffDatetime | sabsDate: 5 }}
              </div>
            }
            @if (detail.vendorName) {
              <div>
                <span i18n="@@itineraryVendor">Vendor:</span>
                {{
                  detail.vendorName.length <= 2
                    ? (detail.vendorName | carVendorFullName)
                    : (detail.vendorName | titlecase)
                }}
                <app-basket-car-details
                  [class.basket-panel]="!hideIcon"
                  [hideIcon]="hideIcon"
                  [car]="car"
                ></app-basket-car-details>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (!duplicateBooking) {
      @for (user of travellers; track user) {
        <div class="traveller-name">
          <b>{{ user.forename }}, {{ user.surname }}</b>
        </div>
      }
    }
    @if (car.price >= 0) {
      <div class="cart_item_price">
        @if (duplicateBooking) {
          <strong i18n="@@basketPanelCostCarHire">Cost</strong>
        }
        <strong>{{ car.price | currency: car.currency }}</strong>
        @if (car.convertedCurrencyCode) {
          <span class="converted_currency"
            >&nbsp;(<span i18n="@@ratesHotelApproxRate">Approx</span>:
            {{ car.convertedCurrencyAmount | currency: car.convertedCurrencyCode }})</span
          >
        }
        @if (!duplicateBooking) {
          <em i18n="@@basketPanelTotalPriceCarHire">&nbsp;Total Price</em>
        }
      </div>
    }
  </div>
</div>
